import React from 'react'
import { Grid, Typography, makeStyles, Button } from '@material-ui/core'
import NotificationsSummary from 'components/Shell/NotificationsSummaryPopover/notificationsSummary'
import { withRouter } from 'react-router-dom'
import 'components/styles/scrollBlueSections.css'

const useStyles = makeStyles(theme => ({
   container: {
      height: '421px',
      width: '100%',
      background: '#3264DC0D',
      borderRadius: '7px',
      boxShadow: '0px 1px 2px #00000029',
      display: 'flex',
      flexDirection: 'column'
   },
   header: {
      padding: theme.spacing(1.5, 3)
   },
   body: {
      height: '321px',
      overflow: 'auto',
      flex: '1 1 auto'
   },
   footer: {
      padding: theme.spacing(1, 3)
   },
   notificationTitle: {
      fontWeight: '600',
      fontSize: '18px',
      color: '#43496a'
   },
   button: {
      font: 'normal normal bold 12px/16px Roboto',
      color: '#3264DC'
   }
}))

const Notifications = ({ history }) => {
   const classes = useStyles()

   function goToAllNotifications() {
      history.push('/dashboard/notifications')
   }

   return (
      <Grid className={classes.container}>
         <Grid className={classes.header}>
            <Typography className={classes.notificationTitle}>
               Notificaciones
            </Typography>
         </Grid>
         <Grid className={`${classes.body} blue-scroll-section`}>
            <NotificationsSummary />
         </Grid>
         <Grid className={classes.footer}>
            <Button onClick={goToAllNotifications} className={classes.button}>
               VER TODAS
            </Button>
         </Grid>
      </Grid>
   )
}

export default withRouter(Notifications)
